import * as React from "react";
import * as moment from "moment";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { IDutyOfficerSchedule, IContact } from "@nkr/models/index";
import { IDay } from "./models";

interface IProps {
    show: boolean,
    data: IDutyOfficerSchedule,
    days: IDay[],
    hours: number[],
    officers: IContact[],
    onDelete: (id: number) => void
    onCancel: () => void
}

class DeleteTimeSlot extends React.Component<IProps, {}> {
    handleDelete = () => {
        this.props.onDelete(this.props.data.id);
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        if (this.props.data == null)
            return null;

        const title = 'Remove Officer From Schedule';
        const day = this.props.days.find(x => x.id == this.props.data.dayId);
        const officer = this.props.officers.find(x => x.id == this.props.data.officerId);
        const { startTime, startTimeRaw, endTime } = this.props.data;
        const startTimeText = startTimeRaw == 0 ? 'Midnight' : startTime;
        const splitTime = endTime.split(':');
        const endTimeText = (parseInt(splitTime[0]) + 1) == 24 ? 'Midnight' : moment().hour(parseInt(splitTime[0]) + 1).minute(0).format('HH:mm');

        return (
            <>
                <Modal backdrop='static' show={this.props.show} onHide={this.handleCancel} dialogClassName='delete-duty-officer-schedule'>
                    <Modal.Header closeButton>{title}</Modal.Header>
                    <Modal.Body>
                        <div style={{ marginBottom: 5 }}>Please confirm that you would like to delete the following from the schedule...</div>

                        <blockquote style={{ marginBottom: 0 }}>
                            <Row>
                                <Col xs={12} lg={3}>Day:</Col>
                                <Col xs={12} lg={9}>{day.name}</Col>
                            </Row>
                            <Row>
                                <Col xs={12} lg={3}>Time:</Col>
                                <Col xs={12} lg={9}>{startTimeText} - {endTimeText}</Col>
                            </Row>
                            <Row>
                                <Col xs={12} lg={3}>Officer:</Col>
                                <Col xs={12} lg={9}>{officer.firstName}</Col>
                            </Row>
                        </blockquote>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle='danger' onClick={this.handleDelete}>Delete</Button>
                        <Button bsStyle="primary" onClick={this.handleCancel}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default DeleteTimeSlot;